<script setup lang="ts">
import { computed } from 'vue'
import { useUserStore } from '@/stores/modules/user'
import type { RuneItemType } from '@/types/rune'
import RuneInfo from './RuneInfo.vue'

const userStore = useUserStore()

const props = defineProps<{ runeInfo: RuneItemType; index: number }>()
const emits = defineEmits(['close'])

const equippedRuneInfo = computed(() => {
  const id = userStore.runeEquippedList[props.index]
  return userStore.runeList.find((item) => item.id === id)
})
</script>

<template>
  <div class="rune-comparsion">
    <div class="module equipped">
      <h5>携带中</h5>
      <template v-if="equippedRuneInfo">
        <RuneInfo :rune-info="equippedRuneInfo" :showLock="false" :is-in-items="false" :is-in-comparison="true" @close-compare="emits('close')" />
      </template>
      <template v-else>
        <p style="text-align: center">(未携带)</p>
      </template>
    </div>
    <div class="module in-items">
      <h5>物品栏</h5>
      <RuneInfo :rune-info="runeInfo" :showLock="false" :is-in-items="true" :is-in-comparison="true" @close-compare="emits('close')" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.rune-comparsion {
  display: flex;
  justify-content: space-between;
  h5 {
    margin: 10px 0;
  }
  .module {
    width: calc(50% - 5px);
    border: 2px var(--fontColor) solid;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    flex-flow: column nowrap;
    min-height: 320px;
  }
}
</style>
